import { type BookmakerConfig } from '@cx-modules/odds-grid';

import { trackEvent } from '~/utils/dataLayer';
import { type SubscriptionTerm } from '~/utils/getSubscriptionTerm';

import { type BettingSplitsBet, type ValueBetResult } from './types';

export const trackEvBetClick = ({
	bookmaker,
	result,
}: {
	bookmaker: BookmakerConfig;
	result: ValueBetResult;
}) => {
	trackEvent('value_bet_click', {
		eventLabel: 'Value Bet Click',
		AIProbablity: result.aiProbability,
		ImpliedProbability: result.sportsbookProbability,
		EV: result.expectedValue,
		BestOdds: result.oddsDecimal,
		BookieName: bookmaker.bookmakerName,
		Props: result.marketPropType,
		'Player/Team': result.line ? result.line.name : result.betName,
		Market: result.marketDisplayName,
		Sport: result.categoryName,
		Subevent: result.subeventName,
		trend: result.sportsData.hitRates.last10,
	});
};

export const trackBettingSplitsBetClick = ({
	bet,
	bookmaker,
	categoryName,
	marketDisplayName,
	marketPropType,
	subeventName,
}: {
	bet: BettingSplitsBet;
	bookmaker: BookmakerConfig;
	categoryName: string;
	marketDisplayName: string;
	marketPropType: string;
	subeventName: string;
}) => {
	trackEvent('betting_splits_bet_click', {
		eventLabel: 'Betting Splits Bet Click',
		Market: marketDisplayName,
		BestOdds: bet.oddsDecimal,
		BookieName: bookmaker.bookmakerName,
		Props: marketPropType,
		'Player/Team': bet.betName,
		Sport: categoryName,
		Subevent: subeventName,
		percentageOfBets: bet.betPercentage,
		percentageOfMoney: bet.stakePercentage,
	});
};

export const trackLandingFreeTrialClick = ({
	position,
	userHasCancelledSubscription,
}: {
	position: 1 | 2 | 3 | 4;
	userHasCancelledSubscription: boolean;
}) => {
	trackEvent(
		userHasCancelledSubscription ? 'subscribe_again' : 'try_free_trial',
		{
			eventLabel: userHasCancelledSubscription
				? 'Subscribe Again'
				: 'Try Free Trial',
			position,
		},
	);
};

export const trackLandingSubscriptionClick = ({
	product,
	term,
}: {
	product: number;
	term: SubscriptionTerm;
}) => {
	trackEvent('free_trial_CTA', {
		eventLabel: 'Free Trial CTA',
		product,
		selection: term,
	});
};

export const trackSubscribeConfirmed = ({
	product,
	term,
	userId,
}: {
	product: string;
	term?: SubscriptionTerm;
	userId: number;
}) => {
	trackEvent('paymentVerified', {
		eventLabel: 'Payment Verified',
		product,
		...(term && { selection: term }),
		userId,
	});
};
